export default __webpack_public_path__ + "static/media/static-1.14d12311.webp";